import { ListProcessingStatus, ListStatus } from "@/enum/list.enum";

import { List } from "../schema/list";

/**
 * Why the list's own Re-Run control is or is not available right now (PREC-4994). Extracted from
 * `RerunListButton` so the button and the Sources menu's failed-Maps hint answer with one rule
 * instead of two copies.
 */
export type RerunListGate = "available" | "running" | "stopping" | "archived" | "unconfigured";

type RerunListGateList = Pick<List, "processingStatus" | "status" | "archived">;

interface RerunListGateConfig {
	sourceMissing?: boolean;
	sourceManualOnly?: boolean;
}

const PROCESSING_STATUSES: ListProcessingStatus[] = [
	ListProcessingStatus.PROCESSING,
	ListProcessingStatus.API_WAITING,
	ListProcessingStatus.WAITING,
	ListProcessingStatus.DESKTOP_APP,
	ListProcessingStatus.WAITING_FOR_SESSION,
];

/**
 * The order is the one the button renders in: a running list shows its running indicator before
 * any disabled reason, and an archived list names its archive before the other refusals.
 */
export const rerunListGate = (
	list: RerunListGateList,
	config: RerunListGateConfig
): RerunListGate => {
	if (PROCESSING_STATUSES.includes(list.processingStatus)) {
		return "running";
	}

	if (list.archived === true) {
		return "archived";
	}

	if (config.sourceMissing || config.sourceManualOnly) {
		return "unconfigured";
	}

	if (list.status === ListStatus.STOPPING) {
		return "stopping";
	}

	return "available";
};

/**
 * The key of the sentence a user reads on a failed Maps row. The stopping and archived sentences
 * are the Re-Run control's own, so the two surfaces cannot drift apart.
 */
export const rerunListHintKey = (gate: RerunListGate): string => {
	switch (gate) {
		case "available":
			return "list.sources.maps.rerunAvailable";
		case "running":
			return "list.sources.maps.rerunRunning";
		case "archived":
			return "list.rerun.disabledArchived";
		case "stopping":
			return "list.rerun.disabledStopping";
		case "unconfigured":
		default:
			return "list.rerun.disabledSourceMissing";
	}
};
